import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "gatsby";
import slugify from "slugify";

//assets
import doodle from "assets/svg/doodle-eyes.svg";


//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import MainWrapper from "components/global/MainWrapper.js";
import ServicesItem from "components/home/services/ServicesItem.js";
import Btn from "components/global/Btn.js";
import Body from "components/global/typography/text/Body.js";
import PlayBtn from "components/home/header/PlayBtn.js";
import Media from "components/global/Media.js";





const MaskWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-clip-path:circle(30% at 50% 50%);
  clip-path: circle(30% at 50% 50%);

  transition: all 0.3s ease-in-out;



`;

const Wrapper = styled(Link)`
align-self: flex-start;
position: relative;
text-decoration: none;
cursor: pointer;
.work-description {
  margin-top: 1.6rem;
  color: ${colors.white};
  max-width: 60rem;
}
${({ $width }) => css`
width: calc( ${$width}% - ${distances.gapBig/2}rem);
`}
  .bg-media {
    transition: all 0.3s ease-in-out;
    transform: scale(1.15);
  }
  .mask-media {
    transform: scale(1.15);
    transition: all 0.3s ease-in-out;
  }
&:hover {
  
  ${MaskWrapper}{
    -webkit-clip-path: circle(40% at 50% 50%);
    clip-path: circle(40% at 50% 50%);
    transition: all 0.3s ease-in-out;
  }
  .mask-media {
    transition: all 0.3s ease-in-out;
    transform: scale(1);
  }
  .bg-media {
    transition: all 0.3s ease-in-out;
    transform: scale(1.3);
  }
}

@media all and (max-width: ${mediaQuery.laptop}) {
  width: 100%;
}
`;

const Title = styled.h3`
font-size: ${typographySizes.text.tekstSize6.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize6.lineHeight};
color: ${colors.white};
position: absolute;
left: 1rem;
bottom: 1rem;
 
@media all and (max-width: ${mediaQuery.laptop}) {
  font-size: ${typographySizes.text.tekstSize6.size.mobile}rem;
}


`;

const MediaWrapper = styled.div`
aspect-ratio: 16/9;
position: relative;
overflow: hidden;
border-radius: ${distances.radius}rem;
`;

const TagsWrapper = styled.div`
display: flex;
flex-wrap: wrap;
gap: 0.4rem;
margin-top: 0.8rem;
flex-direction: row-reverse;
`;

const Tag = styled.span`
font-size: ${typographySizes.text.tekstSize0.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize0.lineHeight};
font-weight: 500;
color: ${({ $darkTags }) => $darkTags ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)"};
background-color: ${({ $darkTags }) => $darkTags ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
padding: 0.6rem 0.8rem;
border-radius: 0.2rem;
white-space: nowrap;
@media all and (max-width: ${mediaQuery.tablet}) {
  font-size: ${typographySizes.text.tekstSize0.size.mobile}rem;
}
`;
const Work = ({ data, index, darkTags, service }) => {
  const widths = [41.66, 50, 50, 41.66];
  const width = widths[index % widths.length];

  return (
    <Wrapper to={`/portfolio/${slugify(data.Title, { lower: true, strict: true })}`} $width={width} $darkTags={darkTags}>
      <MediaWrapper>
  <Media  className="bg-media"media={data.Thumbnail_media} />
  <MaskWrapper>
  <Media className="mask-media"  media={data.Thumbnail_media} />
  </MaskWrapper>
  <Title>{data.Title}</Title>
  </MediaWrapper>

  <TagsWrapper >

  {data.content_types.map((tag) => (
    <Tag $darkTags={darkTags} key={tag.id}>{tag.Name}</Tag>
  ))}
  {data.purposes.map((tag) => (
    <Tag $darkTags={darkTags} key={tag.id}>{tag.Name}</Tag>
  ))}
  {data.niches.map((tag) => (
    <Tag $darkTags={darkTags} key={tag.id}>{tag.Name}</Tag>
  ))}
  </TagsWrapper>
  {data.Description && !service && (
<Body className="work-description">
  {data.Description}
</Body>
)}
    </Wrapper>
  );
};

export default Work;
